import * as React from "react";
import { ModelState } from "../../Models/ModelStateEnum";
import PbhAlternatePnView from "./PbhAlternatePnView";
import PbhRequestAlternatePnCreate from "./PbhRequestAlternatePnCreate";
import { PbhRequestStatus } from "../../../../../src/Enums/PbhRequestStatus";
import { useAuth } from "@airborne/react-admin";

const PbhRequestAlternatePn = props => {
  const { user } = useAuth();
  const readonlyStatusList = [PbhRequestStatus.Accomplished, PbhRequestStatus.Rejected, PbhRequestStatus.Cancelled];
  const [isOfferAnotherPn, setIsOfferAnotherPn] = React.useState(false);
  const [tabType, setTabType] = React.useState(ModelState.Create);
  const [readonly, setReadonly] = React.useState(false);
  React.useEffect(() => {
    var tempTabType =
      props?.requestAlternatePn?.length == 0 && user?.isCustomer === false ? ModelState.Create : ModelState.View;
    setTabType(tempTabType);
  }, [props?.requestAlternatePn]);
  React.useEffect(() => {
    if (props.isPageDisabled || readonlyStatusList.includes(props?.requestDetailData?.requestStatus)) {
      setReadonly(true);
    } else {
      setReadonly(false);
    }
  }, [props?.requestDetailData?.requestStatus, props.isPageDisabled]);
  const finalCallBack = e => {
    setIsOfferAnotherPn(false);
    props.parentCallBack();
  };

  return (isOfferAnotherPn || tabType === ModelState.Create) && !readonly ? (
    <PbhRequestAlternatePnCreate
      readonly={readonly}
      resource="/pbhrequestalternatepns"
      basePath=""
      requestId={props.requestId}
      requestAlternatePn={props.requestAlternatePn}
      requestDetail={props.requestDetailData}
      finalCallBack={finalCallBack}
    />
  ) : (
    <PbhAlternatePnView
      readonly={readonly}
      resource="/pbhrequestalternatepns"
      basePath=""
      requestId={props.requestId}
      requestAlternatePn={props.requestAlternatePn}
      requestDetail={props.requestDetailData}
      finalCallBack={e => props.parentCallBack()}
      offerAnotherPnClick={setIsOfferAnotherPn}
      createFinalCallBack={finalCallBack}
    />
  );
};

export default PbhRequestAlternatePn;
